import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { BranchOffice, branchOfficeType } from '../../types/slices/branchOfficeType'

const initialState: branchOfficeType =
{
    status: ApiStatus.FETCHED,
    branchOffices: [],
    branchOfficeSelected: {} as BranchOffice,
    errorMessage: undefined,
    action: ''
}

const branchOfficeSlice = createSlice({
    name: 'branchOfficeSlice',
    initialState,
    reducers: {
        onFetchbranchOffice (state, { payload }: { payload: BranchOffice[]}) {
            state.status = ApiStatus.FETCHED
            state.branchOffices = payload
            state.errorMessage = undefined
        },
        onSetSelectedbranchOffice (state, { payload }: { payload: BranchOffice }) {
            state.branchOfficeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectBranchOfficeState = (state: RootState) => state.branchOfficeSlice
export default branchOfficeSlice.reducer
export const {
    onFetchbranchOffice,
    onSetSelectedbranchOffice,
    changeStatus,
    setAction,
} = branchOfficeSlice.actions
